var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinStoreDefaultLtr = function SvgPinStoreDefaultLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50 0C31.775 0 17 14.904 17 33.29a33.4 33.4 0 0 0 3.853 15.624l26.784 49.67c1.004 1.86 3.628 1.888 4.68.081l9.056-16.713 8.736-16.171c4.365-8.095 7.51-13.962 9.062-16.913A33.4 33.4 0 0 0 83 33.29C83 14.905 68.225 0 50 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M41.827 60.63c.622.238 1.297.37 2.003.37V40.734a13.42 13.42 0 0 0 7.914 2.57c7.484 0 13.551-6.112 13.551-13.652S59.228 16 51.745 16c-3.248 0-6.227 1.15-8.561 3.07h-4.99v36.25c0 1.741.778 3.299 2.002 4.34zm9.917-38.951c4.37 0 7.914 3.57 7.914 7.973s-3.543 7.974-7.914 7.974-7.915-3.57-7.915-7.974 3.544-7.973 7.915-7.973",
    clipRule: "evenodd"
  })));
};
export default SvgPinStoreDefaultLtr;